import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-dashboard-archives',
  templateUrl: './dashboard-archives.component.html',
  styleUrls: ['./dashboard-archives.component.scss']
})
export class DashboardArchivesComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
